export default __webpack_public_path__ + "partner_12a98bb1.png";